var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav-item-dropdown',{attrs:{"text":_vm.locale,"right":"","data-cy":"locale-switcher"}},_vm._l((_vm.languages),function(language){return _c('b-dropdown-item',{key:language,attrs:{"data-cy":language},on:{"click":function($event){return _vm.switchLocale(language)}}},[_vm._v(" "+_vm._s(language)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }